<template>
  <div>
    <v-card outlined>
      <v-card-title class="title">
        {{ $tt('customBillingExistingCard') }}
      </v-card-title>
      <v-card-text>
        <!-- 登録済みカードがない場合 -->
        <v-alert elevation="2" icon="mdi-alert" outlined text v-if="getCards().length === 0">
          {{ $tt('customCreditCardNoCard') }}
        </v-alert>
        <v-list two-line>
          <template v-for="(card, index) in getCards()">
            <v-list-item :key="index" :class="{ yellow: card.defaultCard, 'lighten-5': card.defaultCard }">
              <v-list-item-avatar>
                <credit-card-brand-icon :credit-card="card" :width="42" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <credit-card-description :credit-card="card" />
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ card.name }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip color="success" outlined v-if="card.defaultCard">
                  <v-avatar left>
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-avatar>
                  {{ $tt('customSelected') }}
                </v-chip>
                <v-btn @click="selectCard(card)" v-if="!card.defaultCard" small>
                  {{ $tt('customSelectThis') }}
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn @click="openDeleteCardDialog(card)" small>
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog v-model="isShowingDeleteDialog" persistent max-width="300">
      <v-card>
        <v-card-title>{{ $tt('customConfirmReally') }}</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="isShowingDeleteDialog = false">
            {{ $tt('customCancel') }}
          </v-btn>
          <v-btn @click="deleteCard()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <now-loading-overlay-component :nowLoading="nowLoading" />
  </div>
</template>

<script>
import CreditCardBrandIcon from '@/components/billing/CreditCardBrandIcon'
import CreditCardDescription from '@/components/billing/CreditCardDescription'
import NowLoadingOverlayComponent from '@/components/NowLoadingOverlayComponent'
import StripeInfo from '@/lib/stripe-info'
import Toast from '@/lib/toast'
import i18n from '@/lib/i18n'
export default {
  name: 'CreditCardListComponent',
  components: { CreditCardBrandIcon, CreditCardDescription, NowLoadingOverlayComponent },
  data() {
    return {
      nowLoading: false,
      isShowingDeleteDialog: false,
      cardForDelete: null,
    }
  },
  methods: {
    getCards() {
      return StripeInfo.getCards()
    },
    openDeleteCardDialog(card) {
      this.isShowingDeleteDialog = true
      this.cardForDelete = card
    },
    deleteCard() {
      const params = {
        card: this.cardForDelete,
        onSuccess: this.closeDeleteCardDialog,
        onFailure: this.onDeleteCardFailure,
      }
      this.nowLoading = true
      this.$store.dispatch('deleteStripeCreditCard', params)
    },
    closeDeleteCardDialog() {
      this.nowLoading = false
      this.isShowingDeleteDialog = false
      this.cardForDelete = null
    },
    onDeleteCardFailure(errorResponse) {
      this.nowLoading = false
      Toast.i18nError('customCreditCardDeleteFailure')
      console.error(errorResponse)
    },
    selectCard(card) {
      this.nowLoading = true
      const params = {
        card: card,
        onSuccess: this.closeNowLoading,
        onFailure: this.closeNowLoading,
      }
      this.$store.dispatch('selectStripeCreditCard', params)
    },
    closeNowLoading() {
      this.nowLoading = false
    },
  },
}
</script>
